<template>
  <div v-if="company">
    <SubHeader title="Suppression Details" />

    <b-row class="my-1">
      <b-col md="3"> </b-col>
      <b-col md="9">
        <b-form-checkbox v-model="company.doNotMail"
                         :disabled="disableDoNoMail()">
          Do not mail
        </b-form-checkbox>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3"> </b-col>
      <b-col md="9">
        <b-form-checkbox v-model="company.doNotEmail"
                         :disabled="disableDoNoEmail()">
          Do not email
        </b-form-checkbox>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3"> </b-col>
      <b-col md="9">
        <b-form-checkbox v-model="company.doNotCall"
                         :disabled="disableDoNoCall()">
          Do not call
        </b-form-checkbox>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3"> </b-col>
      <b-col md="6">
        <b-button class="my-1 margin-right"
                  variant="success"
                  type="button"
                  @click="showModal"><font-awesome-icon icon="save" />&nbsp;Save</b-button>
      </b-col>
    </b-row>
    <b-row v-if="showSuppressionRequesButton()" class="my-1">
      <b-col md="3"> </b-col>
      <b-col md="6">
        <b-button class="my-1 margin-right"
                  variant="success"
                  type="button"
                  @click="showRequestModal"><font-awesome-icon icon="envelope" />&nbsp;Request Suppression</b-button>
      </b-col>
    </b-row>
    <CompanySuppressionModal :company="company" ref="suppressionModal" />
    <CompanyRequestSuppressionChangeModal :companyId="parseInt(companyId)" ref="suppressionChangeModal" />

  </div>
</template>

<script>
import SubHeader from "@/components/shared/SubHeader.vue";
  import CompanySuppressionModal from "@/components/company/suppression/CompanySuppressionModal.vue";
  import CompanyRequestSuppressionChangeModal from "@/components/company/suppression/CompanyRequestSuppressionChangeModal.vue";
//import store from '@/helpers/Store'

export default {
    components: { SubHeader, CompanySuppressionModal, CompanyRequestSuppressionChangeModal },
  props: {
    initialCompany: Object,
    currentUser: Object,
    companyId: String,
  },
  data() {
    return {
      company: null
    }
  },
  mounted() {
    if (this.initialCompany && this.company == null) {
      this.company = {...this.initialCompany};
    }
  },
  watch: {
    initialCompany: function() {
      this.company = {...this.initialCompany};
    },
  },
  methods: {
    showModal() {
      this.$refs.suppressionModal.showModal();
    },
    showRequestModal() {
      this.$refs.suppressionChangeModal.showModal();
    },
    disableDoNoMail() {
      if (this.currentUser.hasAdmin == 0 && (this.company.buyerIsSuppressed == 1 || this.company.buyerDoNotMail || this.company.hasSignedNda)) {
        return true;
      }
      return false;
    },
    disableDoNoEmail() {
      if (this.currentUser.hasAdmin == 0 && (this.company.buyerIsSuppressed == 1 || this.company.buyerDoNotEmail || this.company.hasSignedNda)) {
        return true;
      }
      return false;
    },
    disableDoNoCall() {
      if (this.currentUser.hasAdmin == 0 && (this.company.buyerIsSuppressed == 1 || this.company.buyerDoNotCall || this.company.hasSignedNda)) {
        return true;
      }
      return false;
    },
    showSuppressionRequesButton() {
      if (this.currentUser.hasAdmin == 0 && (this.company.buyerIsSuppressed == 1 || this.company.buyerDoNotMail || this.company.buyerDoNotEmail || this.company.buyerDoNotCall || this.company.hasSignedNda)) {
        return true;
      }
      return false;
    }
  },
};
</script>
